import { DataLayer } from '@grandvisionhq/analytics';

function pushLoginAction(page) {
    DataLayer.pushEvent(createEvent('not logged', 'login to start your eye exam', page));
}
function pushCheckedConsent(page) {
    DataLayer.pushEvent(createEvent('logged', 'consent', page));
}
function pushStartEyeTest(page) {
    DataLayer.pushEvent(createEvent('logged', 'start eye test', page));
}
function createEvent(status, interaction, page) {
    return {
        event: 'VirtualTest',
        VirtualEyetest: {
            action: {
                status,
                interaction,
                page
            }
        }
    };
}

export { createEvent, pushCheckedConsent, pushLoginAction, pushStartEyeTest };
//# sourceMappingURL=data-layer.js.map
